export const getGiftCardAmount = state => state.giftCard.get('amount');
export const getGiftCardBarber = state => state.giftCard.get('barber');



// WEBPACK FOOTER //
// ./src/app/giftCard/selectors.js